module.exports = __webpack_public_path__ + "static/media/logo.56b21fa0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/config/assets/logo.svg
// module id = 1069
// module chunks = 0